import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-software-partner',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './software-partner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './software-partner.component.scss'
})
export class SoftwarePartnerComponent {

}
